import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";
import { allNewsListMockData } from "../../mocks/newsOverviewData";
import { newsDropdownDataMock } from "../../mocks/newsDropdownData";


const FetchCommodityLandingAction = () => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/risi/main-page-data`);
        var resData = Object.assign({ type: 'SUCCESS_COMMODITY_MAIN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchRISIDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/risi/sector-bu-hierarchy`);
        var resData = Object.assign({ type: 'SUCCESS_RISI_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchRISISecondaryDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi/dropdown-hierarchy`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RISI_SEC_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchRISIDetailAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi/kpi-page-data`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_RISI_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchRISIDropdownV2Action = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi/sector-bu-hierarchy-v2`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RISI_DROPDOWN_V2_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchRISISecondaryDropdownV2Action = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi/dropdown-hierarchy-v2`, postData);
        var resData = Object.assign({ type: 'SUCCESS_RISI_SEC_DROPDOWN_V2_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchRISIDetailV2Action = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi/kpi-page-data-v2`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_RISI_DETAIL_VIEW_V2_ACTION' }, data);
        dispatch(resData);
    }
}

const FetchNewsDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/risi-news/sector-bu-hierarchy`);
        var resData = Object.assign({ type: 'SUCCESS_NEWS_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchNewsSecondaryDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi-news/commodity-location-hierarchy`,postData);
        var resData = Object.assign({ type: 'SUCCESS_NEWS_SEC_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchNewsDropdownDataAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi-news/dropdown-data`, postData);
        var resData = Object.assign({ type: 'SUCCESS_NEWS_DROPDOWN_DATA_ACTION' }, data);
        dispatch(resData);
    };
};


const FetchAllNewsListAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi-news/news-overview`,postData);
        var resData = Object.assign({ type: 'SUCCESS_ALL_NEWS_LIST_ACTION' }, data);
        dispatch(resData);
    };
}

const FetchAllNewsListActionV2 = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi-news/news-overview-v2`, postData);
        var resData = Object.assign({ type: 'SUCCESS_ALL_NEWS_LIST_ACTION' }, data);
        dispatch(resData);
    };
}

const FetchNewsDetailAction = (id,email) => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/risi-news/news-content?newsId=${id}&emailId=${email}`);
        var resData = Object.assign({ type: 'SUCCESS_NEWS_DETAIL_ACTION' }, data);
        dispatch(resData);
    };
}


const FetchBookmarkListAction = (email) => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/risi-news/bookmark-overview?emailId=${email}`);
        var resData = Object.assign({ type: 'SUCCESS_BOOKMARK_LIST_ACTION' }, data);
        dispatch(resData);
    };
}


const UpdateBookmarkAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi-news/bookmark-request`,postData);
        var resData = Object.assign({ type: 'SUCCESS_UPDATE_BOOKMARK_ACTION' }, data);
        dispatch(resData);
    };
}

const FetchShareListAction = (email) => {
    return async function (dispatch) {
        const data = await getApiCall(`${appConstants.BASE_URL}/risi-news/search-users?emailId=${email}`);
        var resData = Object.assign({ type: 'SUCCESS_SHARE_LIST_ACTION' }, data);
        dispatch(resData);
    };
}

const ShareRisiNewsEmailAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/risi-news/share-news-article`, requestObj);
        var resData = Object.assign({ type: 'SUCCESS_SHARE_NEWS_EMAIL_ACTION' }, data);
        dispatch(resData);
    }
}
export {
    FetchCommodityLandingAction,
    FetchRISIDropdownAction,
    FetchRISIDetailAction,
    FetchRISISecondaryDropdownAction,
    FetchRISIDropdownV2Action,
    FetchRISISecondaryDropdownV2Action,
    FetchRISIDetailV2Action,
    FetchNewsDropdownAction,
    FetchNewsSecondaryDropdownAction,
    FetchNewsDropdownDataAction,
    FetchAllNewsListAction,
    FetchAllNewsListActionV2,
    FetchNewsDetailAction,
    UpdateBookmarkAction,
    FetchBookmarkListAction,
    FetchShareListAction,
    ShareRisiNewsEmailAction
}